import React, { JSX, lazy, Suspense } from 'react';

const LazyprivacyPolicy = lazy(() => import('.'));

const privacyPolicy = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyprivacyPolicy privacyPolicy={[]} {...props} />
  </Suspense>
);

export default privacyPolicy;
